module.exports = __webpack_public_path__ + "img/atn-stamp.fbb82a1e.png";